import { ImResponse, omsClient, resolve, doorClient, messDoorClient } from 'services/api';

export interface TaskListParams {
  scenarioType: Marketing.AllScenarioType;
  platform: General.PlatformUpperCase;
  keyword: string;
  pageNum: number;
  pageSize: number;
}

export interface PageResponse {
  pageNum: number;
  pageSize: number;
  totalRows: number;
}

export interface TaskListResponse {
  pages: PageResponse;
  data: Aide.Task[];
}

export function taskList({ scenarioType, ...params }: TaskListParams) {
  return resolve(
    omsClient.get<ImResponse<TaskListResponse>>(`/active/task/summary/${scenarioType}`, { params }),
  );
}

export interface OverviewParams {
  scenarioType: Marketing.StockoutScenarioType;
  platform: General.PlatformUpperCase;
}

export interface OverviewResponse {
  todayDispatch: number;
  todayLimit: number;
  monthDispatch: number;
}

export function overview({ scenarioType, ...params }: OverviewParams) {
  return resolve(
    omsClient.get<ImResponse<OverviewResponse>>(`/active/overview/${scenarioType}`, {
      params,
    }),
  );
}

export type LogListType = TaskListParams;

export interface LogListResponse {
  pages: PageResponse;
  data: Aide.TaskLog[];
}

export function logList({ scenarioType, ...params }: LogListType) {
  return resolve(
    omsClient.get<ImResponse<LogListResponse>>(`/active/log/${scenarioType}`, { params }),
  );
}

export function startTask(taskId: string | number) {
  return omsClient.post(`/active/task/start/${taskId}`, null);
}

export function stopTask(taskId: string | number) {
  return omsClient.post(`/active/task/stop/${taskId}`, null);
}

export function exportTaskDetail({
  taskId,
  ...params
}: {
  taskId: string | number;
  lang: General.SystemLanguage;
  status: 'ALL' | 'FAIL' | 'SUCCESS';
}) {
  return resolve(
    omsClient.get<ImResponse<{ ossUrl: string }>>(`/active/task/export/${taskId}`, { params }),
  );
}

/**************************** 商品缺货标记start  **********************/
export const getSpuMarkRecord = (stockRuleId: string) => {
  return resolve<OutofStock.MarkRecord[]>(doorClient.get(`/item/v1/stock_rule/log/${stockRuleId}`));
};

export const getStockRule = (data: OutofStock.SearchParams) => {
  return resolve<{
    pageInfo: {
      pageSize: number;
      pageNo: number;
      hasNext: boolean;
      totalCount: number;
    };
    stockRuleDataList: OutofStock.StockRule[];
  }>(doorClient.post('/item/v1/stock_rule/search', data));
};

export const updateStockRule = (data: OutofStock.UpdateStockRuleParams) => {
  return doorClient.post('/item/v1/stock_rule/update', data);
};

export const getUploadRecord = () => {
  return resolve<OutofStock.UploadRecord[]>(messDoorClient.get('/item/v1/stock_rule/upload'));
};

export const uploadStockRule = (data: {
  fileUrl: string;
  fileName: string;
  templateType: number;
  language: string;
}) => {
  return resolve<{ uploadId: string }>(messDoorClient.post('/item/v1/stock_rule/upload', data));
};

export const getUploadResult = (uploadId: string) => {
  return resolve<OutofStock.UploadResult>(
    messDoorClient.get(`/item/v1/stock_rule/upload/${uploadId}`),
  );
};

/**
 * 新增库存规则
 */
export const addStockRule = (data: OutofStock.AddStockRuleParams) => {
  return doorClient.post('/item/v1/stock_rule/add', data);
};
/**************************** 商品缺货标记end  ************************/
